import { Nullable } from '../../common/types';

export enum Tables {
  Farms = 'farmsTable',
  Settings = 'settingsTable',
  AMFSettings = 'AMFSettingsTable',
  VectorSettings = 'vectorSettingsTable',
  HubDevices = 'hubDevicesTable',
}

export type TableName = `${Tables}`;

export namespace FarmOptionsTypes {
  export type Selection = {
    key: string;
    name: string;
    searchable?: boolean;
    order?: number;
    externalId?: string;
  };

  export type InitialState = {
    selectedColumns: Nullable<Record<string, Selection[]>>;
  };
}
